import React from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
const SelectBox = ({
  id,
  label,
  options,
  placeholder,
  value,
  onChange,
  errorText,
  className = '',
  labelClassName = '',
  isSearchable = true,
  menuPlacement = 'auto',
  classNamePrefix = 'Select2',
  required=false,
  isClearable = false,
  ...rest
}) => {
  return(
  <div className={`select-box-container ${className}`}>
    {label && (
      <label htmlFor={id} className={`form-label mt-3 ${labelClassName}`}>
        {label}{required && <span style={{ color: 'red' }}>*</span>}
      </label>
    )}
    <Select
      className="ti-form-select rounded-sm !p-0"
      id={id}
      options={options}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      isSearchable={isSearchable}
      menuPlacement={menuPlacement}
      isClearable={isClearable}
      // className={`w-full !rounded-md`}
      classNamePrefix={classNamePrefix}
      menuPortalTarget={document.body}
      menuShouldScrollIntoView={false}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({
          ...base,
          maxHeight: '200px',
          overflowY: 'auto',
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: '200px',
          overflowY: 'auto',
        }),
      }}
      {...rest}
    />
    {errorText && (
      <label htmlFor={id} className="mt-1 text-[0.75rem] opacity-[0.8] !mb-0" style={{ color: 'red' }}>
        {errorText}
      </label>
    )}
  </div>
)}

SelectBox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errorText: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  isSearchable: PropTypes.bool,
  menuPlacement: PropTypes.string,
  classNamePrefix: PropTypes.string,
  required: PropTypes.bool,
  isClearable: PropTypes.bool,
}

export default SelectBox
